import { render, staticRenderFns } from "./ZyroImageSelector.vue?vue&type=template&id=b493549a&scoped=true&"
import script from "./ZyroImageSelector.vue?vue&type=script&lang=js&"
export * from "./ZyroImageSelector.vue?vue&type=script&lang=js&"
import style0 from "./ZyroImageSelector.vue?vue&type=style&index=0&id=b493549a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b493549a",
  null
  
)

export default component.exports